export const useToast = () => {
  const showSuccessToast = () => {
    const addToast = document.getElementById('success-toast')
    if (addToast) addToast.classList.remove('hidden')
    setTimeout(() => {
      const addToast = document.getElementById('success-toast')
      if (addToast) addToast.classList.add('hidden')
    }, 3000)
  }

  const showErrorToast = () => {
    const errorToast = document.getElementById('error-toast')
    if (errorToast) errorToast.classList.remove('hidden')
    setTimeout(() => {
      const errorToast = document.getElementById('error-toast')
      if (errorToast) errorToast.classList.add('hidden')
    }, 3000)
  }

  return {
    showSuccessToast,
    showErrorToast,
  }
}